<template>
  <v-ons-list
    class="item-detail"
    modifier="noborder"
  >
    <item-outline :thing="destination" />
    <v-ons-list-item modifier="longdivider">
      <div class="left list-label">
        <img src="~@/assets/images/icon-memo.svg">メモ
      </div>
      <div class="center">
        {{ destination.item.memo }}
      </div>
    </v-ons-list-item>
  </v-ons-list>
</template>

<script>
import itemOutline from '@/components/map/partials/destination_outline/item.vue';

export default {
  components: { itemOutline },
  computed: {
    destination: ({ $store }) => $store.state.searchResult.destination,
  },
};
</script>

<style scoped lang="scss">
.item-detail {
  font-size: 18px;
}
.list-label {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// item.vue?44dda6ca